/**
 * The employee profile's tabs (NAU-447). Overview is the default and has no
 * `?tab=` value, so a plain `/people/{id}` link still opens it.
 */
export type ProfileTab = "overview" | "details" | "acknowledgements" | "login";

export type ProfileTabParam = Exclude<ProfileTab, "overview">;

export const PROFILE_TAB_PARAMS: ProfileTabParam[] = [
  "details",
  "acknowledgements",
  "login",
];

export const PROFILE_TAB_PANEL_ID = "profile-tab-panel";

export const PROFILE_TAB_LABELS: Record<ProfileTab, string> = {
  overview: "Overview",
  details: "Details",
  acknowledgements: "Acknowledgements",
  login: "Login and security",
};

export function availableProfileTabs(options: {
  canViewLogin: boolean;
}): ProfileTab[] {
  const tabs: ProfileTab[] = ["overview", "details", "acknowledgements"];
  if (options.canViewLogin) {
    tabs.push("login");
  }
  return tabs;
}

/** A link to a tab the viewer doesn't have opens Overview instead. */
export function resolveProfileTab(
  requested: ProfileTabParam | undefined,
  available: readonly ProfileTab[],
): ProfileTab {
  if (!requested) return "overview";
  if (!available.includes(requested)) return "overview";
  return requested;
}

export function profileTabParam(tab: ProfileTab): ProfileTabParam | undefined {
  if (tab === "overview") return undefined;
  return tab;
}

export function isProfileTabParam(value: unknown): value is ProfileTabParam {
  return PROFILE_TAB_PARAMS.includes(value as ProfileTabParam);
}

/** The phone picker's name, with the outstanding count it shows. */
export function sectionPickerLabel(
  label: string,
  outstandingCount: number,
): string {
  if (outstandingCount === 0) return `Section: ${label}`;
  return `Section: ${label}, ${outstandingCount} to sign`;
}
